
export default {

    products(state,data){
        state.products = data
    },

    product(state,data){
        state.product = data
    },

    productCurrencyConfig(state,data){
        state.productCurrencyConfig = data
    }
}